TS.ns('WL');

WL.competenceOrderModel = new Class({
    Extends: TS.domain.EditDomain,

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        rulesList = me.getDomainProperty('dgRulesCollection_Property');
        if (rulesList) {
            cat = rulesList.Commands;

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'AddRule';
            newCmd['Text'] = me.AddRuleCommandText;
            newCmd['handler'] = '_addRule';
            newCmd['IconCode'] = 'plus';
            if (!me.ReadOnly())
                cat.push(newCmd);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'EditRule';
            newCmd['Text'] = me.EditRuleCommandText;
            newCmd['handler'] = '_editRule';
            newCmd['IconCode'] = 'edit';
            if (!me.ReadOnly())
                cat.push(newCmd);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'DeleteRule';
            newCmd['Text'] = me.DeleteRuleCommandText;
            newCmd['handler'] = '_deleteRule';
            newCmd['IconCode'] = 'remove';
            if (!me.ReadOnly())
                cat.push(newCmd);
        }

    },

    _addRule: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'AddRule',
            submitModel: true,
            blockUI: false
        });
    },

    _editRule: function () {
        var me = this;
        rulesList = me.getDomainProperty('dgRulesCollection_Property');

        if (rulesList.SelectedItem() == null) return;

        me.performServerCommand({
            cmd: 'EditRule',
            submitModel: true,
            extraData: { UID: rulesList.SelectedItem().UID() },
            blockUI: false
        });
    },

    _deleteRule: function () {
        var me = this;

        var ruleList = me.getDomainProperty('dgRulesCollection_Property');
        if (ruleList.SelectedItem() != null) {
            me.performServerCommand({
                cmd: 'DeleteRule',
                submitModel: true,
                extraData: null,
                blockUI: true,
                extraData: {
                    UID: ruleList.SelectedItem().UID()
                }
            });
        }
    }
});